import CountryRepository from '../../../networking/repos/CountryRepository';
import {useQueryConfig} from '../Utils';

export const CountryQueryKey = {
    base: (continentId: number) => ['countries', continentId],
};

export const useCountryIndexQueryConfig = (continentId: number) => {
const repo = new CountryRepository(continentId);

    return useQueryConfig(CountryQueryKey.base(continentId), () => {
        if(continentId === -1)
            return Promise.resolve([]);

        return repo.getForContinent(continentId);
    });
};
